import { render, staticRenderFns } from "./WguApp.vue?vue&type=template&id=2e57917b&"
import script from "./WguApp.vue?vue&type=script&lang=js&"
export * from "./WguApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports